import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "advances" }
const _hoisted_2 = { class: "advance-balance panel bg-lighter-grey" }
const _hoisted_3 = { class: "text-body-light margin-0" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "amount" }
const _hoisted_6 = { class: "text-body" }
const _hoisted_7 = { class: "text-body-light" }
const _hoisted_8 = { class: "advance-transactions" }
const _hoisted_9 = { key: 1 }

import { onMounted, ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import dayjs from 'dayjs'
import GroupedAdvance from '@/components/GroupedAdvance.vue'
import Loader from '@/components/CommonUI/Loader.vue'
import Notification from '@/components/CommonUI/Notification.vue'
import PaginationDots from '@/components/CommonUI/PaginationDots.vue'
import { formatAmount } from '@/helpers/formatAmount'
import { getErrorMessage } from '@/helpers/errorHandler'
import { useAdvanceStore } from '@/store'
import { AdvanceType } from '@/constants'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdvancesPage',
  setup(__props) {

const {
  getAdvanceBalance,
  getAdvanceHistory,
  getAllMissingReleases,
  getAllMissingTracks,
} = useAdvanceStore()
const {
  advanceBalance,
  advanceHistory,
  advanceGroupedTransactions,
} = storeToRefs(useAdvanceStore())

const error = ref<string | null>(null)
const isLoadingTransactions = ref(false)

const sortedGroupedTransactions = computed(() => [...advanceGroupedTransactions.value]
  .sort((a, b) => {
    const dateA = dayjs(a.issueDate)
    const dateB = dayjs(b.issueDate)
    return dateA.isBefore(dateB) ? 1 : -1
  }))

async function fetchReleases() {
  try {
    const releaseIds = Array.from(
      new Set(
        advanceGroupedTransactions.value
          .filter(group => group.type === AdvanceType.release)
          .flatMap(group => group.entityIds),
      ),
    )

    if (releaseIds.length) {
      await getAllMissingReleases(releaseIds)
    }

    const trackIds = Array.from(
      new Set(
        advanceGroupedTransactions.value
          .filter(group => group.type === AdvanceType.asset)
          .flatMap(group => group.entityIds),
      ),
    )

    if (trackIds.length) {
      await getAllMissingTracks(trackIds)
    }
  } catch (err) {
    error.value = getErrorMessage(err)
  }
}

async function fetchAdvanceHistory(page: number) {
  try {
    await getAdvanceHistory(page)
    await fetchReleases()
  } catch (err) {
    error.value = getErrorMessage(err)
  }
}

onMounted(async () => {
  try {
    await getAdvanceBalance()

    if (!advanceGroupedTransactions.value.length) {
      isLoadingTransactions.value = true
      await fetchAdvanceHistory(1)
      isLoadingTransactions.value = false
    } else {
      await fetchReleases()
    }
  } catch (err) {
    error.value = getErrorMessage(err)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$gettext('Advances')), 1),
    (error.value)
      ? (_openBlock(), _createBlock(Notification, {
          key: 0,
          "icon-name": "danger",
          title: _ctx.$gettext('Failed retrieving your balance'),
          message: error.value
        }, null, 8, ["title", "message"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$gettext('Total Advance Balance')), 1),
            (!_unref(advanceBalance))
              ? (_openBlock(), _createBlock(Loader, { key: 0 }))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, [
                    _createElementVNode("strong", _hoisted_6, _toDisplayString(_unref(formatAmount)(-_unref(advanceBalance).remainingAmount)), 1)
                  ]),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$gettext('Outstanding repayments due on your account.')), 1)
                ]))
          ]),
          _createElementVNode("div", _hoisted_8, [
            (isLoadingTransactions.value)
              ? (_openBlock(), _createBlock(Loader, { key: 0 }))
              : (sortedGroupedTransactions.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedGroupedTransactions.value, (groupedAdvance) => {
                      return (_openBlock(), _createBlock(GroupedAdvance, {
                        key: `group-advance-${groupedAdvance.transactions[0].id}`,
                        "grouped-advance": groupedAdvance
                      }, null, 8, ["grouped-advance"]))
                    }), 128)),
                    (_unref(advanceHistory).meta!.pagesCount > 1)
                      ? (_openBlock(), _createBlock(PaginationDots, {
                          key: 0,
                          class: "no-space",
                          "current-page": _unref(advanceHistory).meta!.currentPage,
                          "pages-count": _unref(advanceHistory).meta!.pagesCount,
                          onSelectPage: fetchAdvanceHistory
                        }, null, 8, ["current-page", "pages-count"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
          ])
        ], 64))
  ]))
}
}

})